export default defineNuxtRouteMiddleware((to, from) => {
	if (import.meta.client) {
		// Save scroll position when leaving the page
		if (from.name === 'colecao-slug') {
			history.scrollRestoration = 'manual';
		}
		// Restore scroll position when coming back
		if (to.name === 'colecao-slug' && from.name === 'PropertiesListing') {
			nextTick(() => {
				window.scrollTo({ top: 0, behavior: 'instant' });
			});
		}
	}
});
